import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Error404Module } from '@infosysbub/ng-lib-dpl3';

@Component({
    selector: 'ba-studisu-seitenichtgefunden',
    templateUrl: './seitenichtgefunden.component.html',
    imports: [Error404Module]
})
export class SeiteNichtGefundenComponent {
  constructor(private router: Router) {}

  navigateToHome() {
    this.router.navigateByUrl('');
  }
}
